import SpeedTestPage from './SpeedTest';

export default SpeedTestPage;
